import { P } from 'components'
import { useDebounce } from 'helpers'
import { useEffect, useRef, useState } from 'react'
import { Input, Spinner } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getLandplot } from 'features/public-views/manageStock/API/manageStockAction'

const LandplotInputSelection = ({
  title = 'Lokasi Panen',
  placeholderDesc = 'Cari lokasi panen',
  isRequired = false,
  isNetwork = false,
  isLandOwner = false,
  onSelectLandplot,
  isUppercaseValue,
  fieldName,
  invalid,
  editValue,
  isVessel,
  onFetchingChange,
  innerRef,
  className,
  isCloseSelection = false,
  valueName,
}) => {
  const dispatch = useDispatch()
  const [isOpenSelection, setIsOpenSelection] = useState(false)
  const [landplots, setLandplots] = useState([])
  const [localSearch, setLocalSearch] = useState('')
  const [isFetchingLocal, setIsFetchingLocal] = useState(false)
  const [lastActiveField, setLastActiveField] = useState(null)
  const [hasSelected, setHasSelected] = useState(false)

  // const { warehousesAdd, landplots } = useSelector((s) => s.manageStock)

  const wrapperRef = useRef(null)

  const debouncedSearch = useDebounce((value) => {
    const trimmedValue = value.trim()
    if (trimmedValue) {
      setIsFetchingLocal(true)
      dispatch(getLandplot({ search: trimmedValue })).then((response) => {
        setLandplots(response?.payload?.list || [])
        setIsFetchingLocal(false)
        setIsOpenSelection(true)
      })
    } else {
      setIsOpenSelection(false)
      setLandplots([])
    }
  }, 600)

  const handleManualChange = (e) => {
    const value = e.target.value
    setLocalSearch(value)
    setHasSelected(false)

    if (onSelectLandplot) {
      onSelectLandplot(null, fieldName)
    }

    if (value.length > 2) {
      debouncedSearch(value)
    } else {
      setIsOpenSelection(false)
      setLandplots([])
      handleInitialFetch()
    }
  }

  const handleSelectContact = (contact) => {
    const relationName = isUppercaseValue
      ? contact?.label?.toUpperCase()
      : contact?.label

    const displayText = relationName || ''

    setLocalSearch(displayText)
    setIsOpenSelection(false)
    setHasSelected(true)
    if (onSelectLandplot) {
      onSelectLandplot(contact, fieldName)
    }
  }

  const handleInitialFetch = () => {
    setLastActiveField(fieldName)
    // if (!editValue) { // FOR AT THE MOMENT COMMENT THIS HANDLE
    setIsFetchingLocal(true)
    dispatch(getLandplot({})).then((response) => {
      setLandplots(response?.payload?.list || [])
      setIsFetchingLocal(false)
      setIsOpenSelection(true)
    })
    // }
  }

  useEffect(() => {
    return () => {
      setLocalSearch('')
      setLandplots([])
      setLastActiveField(null)
    }
  }, [])

  useEffect(() => {
    if (!hasSelected && editValue) {
      setLocalSearch(editValue)
    }
  }, [editValue])

  useEffect(() => {
    if (!hasSelected && valueName) {
      setLocalSearch(valueName)
    }
  }, [valueName])

  useEffect(() => {
    if (onFetchingChange) {
      onFetchingChange(isFetchingLocal)
    }
  }, [isFetchingLocal, onFetchingChange])

  useEffect(() => {
    if (lastActiveField === fieldName) {
      handleInitialFetch()
    }
  }, [fieldName, lastActiveField])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpenSelection(false)

        if (!hasSelected) {
          setLocalSearch('')
        }
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [hasSelected])

  return (
    <div
      ref={wrapperRef}
      style={{ position: 'relative' }}
      className="w-100"
      data-testid="landplot-selection"
    >
      <P size={isVessel ? 'regular' : 'default'} className="mb-2">
        {title}
        {isRequired && <span className="text-danger">*</span>}
      </P>

      <Input
        className={className}
        type="text"
        value={localSearch}
        onChange={handleManualChange}
        placeholder={placeholderDesc}
        onFocus={handleInitialFetch}
        data-testid="landplot-selection-input"
        // onBlur={() => setTimeout(() => setIsOpenSelection(false), 200)}
        // onBlur={() => {
        //   if (!hasSelected && !isCanClose) {
        //     return
        //   }

        //   setTimeout(() => setIsOpenSelection(false), 200)
        //   setLocalSearch('')
        // }}
        invalid={invalid}
        innerRef={innerRef}
      />
      {isOpenSelection && !isCloseSelection && (
        <div
          style={{
            position: 'absolute',
            background: 'white',
            width: '100%',
            boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
            borderRadius: '8px',
            zIndex: 10,
            marginTop: '4px',
          }}
        >
          <div
            style={{
              maxHeight: '250px',
              overflowY: 'auto',
            }}
          >
            {isFetchingLocal ? (
              <div className="p-3 d-flex justify-content-center align-items-center">
                <Spinner size="sm" color="primary" />
              </div>
            ) : (
              <>
                <>
                  {landplots?.length > 0 ? (
                    landplots?.map((contact, index) => (
                      <div
                        key={index}
                        className="contact-item p-2 d-flex flex-column"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleSelectContact(contact)}
                        data-testid={`landplot-selection-item-${index}`}
                      >
                        <P color="#101828">{contact?.label ?? ''}</P>
                      </div>
                    ))
                  ) : (
                    <div className="p-2 text-muted">
                      Pencarian tidak ditemukan
                    </div>
                  )}
                </>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default LandplotInputSelection
